import React, {Component} from 'react';
import * as productTypes from './../../containers/Products/ProductsValues';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

/**
 * Product Switcher component
 */

class ProductSwitcher extends Component {

  watchScroll = null
  scrollVertical = null;
  scrollIndicator = null;
  watchChange = null;
  shouldWatchChange = false;

  componentDidMount() {
    const scrollEl = document.getElementById("productScrollBar");
    if (scrollEl){
      this.scrollVertical =  scrollEl.getElementsByClassName("simplebar-vertical");
      if (this.scrollVertical){
        this.watchScroll = this.scrollVertical[0].getElementsByClassName("simplebar-scrollbar")[0];
        this.scrollIndicator = document.getElementById("scroll-indicator");

        // Fix the scroll event not beign accurate enough
        this.watchChange = setInterval( () => {
          if (this.shouldWatchChange){
            this.scrollEvent();
          }
        }, 20);
      }
    }
  }

  componentDidUnount() {
    clearInterval(this.watchChange);
  }

  getMatrix(element) {
    const values = element.style.transform.split(/\w+\(|\);?/);
    const transform = values[1].split(/,\s?/g).map(numStr => parseInt(numStr));

    return {
      x: transform[0],
      y: transform[1],
      z: transform[2]
    };
  }

  resetScroll(){
    this.shouldWatchChange = false;
    this.scrollIndicator.style.height = "0px"
  }

  scrollEvent() {
    if (this.watchScroll){
      //let {x,y,z} = this.getMatrix(this.watchScroll);
      //this.scrollIndicator.style.height = (y + (-3)) + "px"
    }
  }

  render() {
    const {openModalWithContent, availableFoodTypes} = this.props;
    const foodCategories = [
      {
        "foodType": productTypes.DRY_FOOD,
        "foodLabel": this.props.data.labelDry
      },
      {
        "foodType": productTypes.WET_FOOD,
        "foodLabel": this.props.data.labelWet
      },
      {
        "foodType": productTypes.RELATED,
        "foodLabel": this.props.data.labelRelated
      },
      {
        "foodType": productTypes.SNACKS,
        "foodLabel": this.props.data.labelSnacks
      }
    ];

    return (
      <div className="nppe2-fc-product-switcher">
        <div className="nppe2-fc-type-of-food__nav-tabs-helper-wrapper">
        <ul className="nav nav-tabs nppe2-fc-type-of-food__nav-tabs">
          {
            foodCategories.map((food, index) => {
              return availableFoodTypes[index] && availableFoodTypes[index].foodType.includes(food.foodType) ?
                <li className={(this.props.selectedCategory === food.foodType ? 'active' : 'passive')}>
                  <a data-toggle="tab"
                    onClick={() => {
                      this.props.onSelectCategory(food.foodType);
                      this.resetScroll();
                    }}
                  >
                    {food.foodLabel}
                  </a>
                  {
                    availableFoodTypes[index].quantityRecommendedProducts.length ?
                      <p class="quantity-recommended">
                        {availableFoodTypes[index].quantityRecommendedProducts.length}
                      </p>
                    : null
                  }
                </li>

              : null
            }, this)
          }
        </ul>
        <div className="nppe2-fc-type-of-food__help-info">
        </div>

              <a href="#" aria-label={this.props.data.aria}>
                <div className="nppe2-fc-info-button"
                  onClick={ (e) => {
                    openModalWithContent("FoodTypeInfo");
                    e.preventDefault();
                  }}>
                </div>
              </a>
            </div>


        <div className="tab-content nppe2-fc-type-of-food__tab-content">
          <div id="scroll-indicator" className="scroll-indicator"></div>

          <SimpleBar
            id="productScrollBar"
            forceVisible={true}
            style={{
              maxHeight: 200
            }}
            scrollableNodeProps={{ tabIndex: 0 }}
            onScroll={()=>{
              this.shouldWatchChange = true;
              this.scrollEvent();
            }}
            autoHide={false}>
              <div id="dry-food" className="tab-pane fade in active nppe2-fc-type-of-food__tab-pane">
                {
                  this.props.products.map((product,i) =>
                      <div
                          className={
                              "nppe2-fc-type-of-food__item " +
                              product.class + " " +
                              (this.props.selected.includes(product.id) ?
                                  'focus' :
                                  this.props.greyed[product.types[0]] ?
                                      'disabled'
                                      : ''
                              ) + " " + (
                                product.points <= 1 ? ' nppe2-fc-type-of-food__low-points ' : ''
                              ) + " product-points__" + product.points
                            }
                          key={i}
                          title={product.pointsDetails}
                          onClick={(this.props.selected.includes(product.id) ?
                              () => this.props.onRemove(product.id) :
                              !this.props.greyed[product.types[0]] ?
                                  () => this.props.onSelect(product.id, product):
                                  () => void(0)
                              )
                          }
                      >
                        <div className="nppe2-fc-type-of-food__item-dot">&bull;</div>

                        <div className="nppe2-fc-type-of-food__item-text">
                          {product.shortName}
                        </div>

                        <div className="nppe2-fc-type-of-food__item-add-close">
                          <a />
                        </div>
                      </div>
                  )
                }
              </div>
            </SimpleBar>
        </div>
      </div>
    )
  };
};


export default ProductSwitcher;
